module.exports = __webpack_public_path__ + "img/W7009-thumb.4cdc4ba2.jpg";